import { connect } from 'react-redux';
import type { RootState } from 'reduxStore/reducers';
import Wahanda from 'common/wahanda';
import { PaymentContainer as PaymentContainerComponent } from './PaymentContainer';
import { withStripe } from './Stripe';

const mapStateToProps = (state: RootState) => {
  return {
    idealSupported: Wahanda.Permissions.canUseIdealPayment(),
    // Hide the bank-transfer option when we have no receiving account to show.
    hasBankDetails: Boolean(state.bankDetails.bankAccountNumber),
  };
};

const connector = connect(mapStateToProps);

export const PaymentContainer = connector(withStripe(PaymentContainerComponent));
